import request from '@/utils/request'
import qs from 'qs'
//搜索
export function essearch (params) {
  return request({
    url: '/business/search?' + qs.stringify(params),
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
    token: true,
  })
}
//字典
export function getDictType (params) {
  return request({
    url: '/public/dict/type/' + params.dictType,
    method: 'get'
  })
}
export function getDictTypeTree (params) {
  return request({
    url: '/public/dictTree/type/' + params.dictType,
    method: 'get'
  })
}
export function getDynastyJapan () {
  return request({
    url: '/public/dict/type/bus_dynasty_japan_type/',
    method: 'get'
  })
}

//书籍树形结构
export function booksTree (params) {
  return request({
    url: '/business/book/treeNode?parentId=' + params.parentId + '&nodeType=' + params.nodeType,
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
    token: true,
  })
}
//获取文章列表
export function getArticleList (params) {
  return request({
    url: '/public/articleList',
    method: 'get',
    params: params || {}
  })
}
//书籍详情
export function bookInfo (params) {
  return request({
    url: '/business/book/bookInfo/' + params.bookId,
    method: 'get',
    token: true,
  })
}
//书页信息
export function bookPage (params) {
  return request({
    url: '/business/book/bookPage',
    method: 'get',
    params: params,
    token: true,
  })
}

//书页信息
export function singlePage (params) {
  return request({
    url: '/business/book/singlePage',
    method: 'get',
    params: params,
    token: true,
  })
}
//书页信息
export function bookThumb (params) {
  return request({
    url: '/business/book/bookThumb',
    method: 'get',
    params: params,
    token: true,
  })
}

//书分类【新增】
export function categoryTree (params) {
  return request({
    url: '/business/book/categoryTree',
    method: 'get',
    token: true,
  })
}

//阅读记录
export function read (params) {
  return request({
    url: '/business/read',
    method: 'post',
    data: params,
    token: true,
  })
}
//手机验证码登录
export function smsLogin (params) {
  return request({
    url: '/sms/login',
    method: 'post',
    data: params
  })
}
//获取手机验证码
export function smsCode (params) {
  return request({
    url: '/sms/code',
    method: 'post',
    data: params
  })
}

export function feedbackAdd (params) {
  return request({
    url: '/business/feedback/add',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    params: params,
    token: true,
  })
}

export function getInfo (params) {
  return request({
    url: '/business/user/getInfo',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    params: params,
    token: true,
  })
}

// 我的
export function getNoteList (params) {
  return request({
    url: "/business/note/listSummary",
    method: "get",

    params: params
  })
}
export function getNoteListNew (params) {
  return request({
    url: "/business/note/list",
    method: "get",

    params: params
  })
}

export function deletBookNote (params) {
  return request({
    url: "/business/note/delete/" + params.noteId,
    method: "DELETE"
    // params: params
  })
}
export function getFavorStatus (params) {
  return request({
    url: "/business/favor/isFavor/" + params,
    method: "get"
  })
}
export function addFavordData (params) {
  return request({
    url: "/business/favor/add",
    method: "post",
    data: params
  })
}
export function getFavordData (params) {
  return request({
    url: "/business/favor/list",
    method: "get",
    params: params
  })
}

export function deleteFavor (params) {
  return request({
    url: "/business/favor/delete/" + params,
    method: "DELETE"
    // params: params
  })
}

export function deleteRead (params) {
  return request({
    url: "/business/read/deleteByBookId/" + params,
    method: "DELETE"
    // params: params
  })
}

export function addRead (params) {
  return request({
    url: "/business/read",
    method: "post",
    data: params
  })
}
export function exportNotes (params = {}) {
  return request({
    url: "/business/note/export",
    method: "post",
    data: params,
    responseType: "blob"
  })
}

export function deleteNotesByBook (bookIds) {
  return request({
    url: "/business/note/deleteByBookId/" + bookIds,
    method: "DELETE"
  })
}
export function getReadList (params) {
  return request({
    url: "/business/read/list",
    method: "get",
    params
    // responseType: 'blob'
  })
}
export function updateBaseInfo (params) {
  return request({
    url: "/business/user/updateBaseInfo",
    method: "post",
    data: params
  })
}

//订单列表/api-biz/business/order/list
export function orderList (params) {
  return request({
    url: "/business/order/list",
    method: "get",
    params
  })
}

//取消订单/api-biz/business/order/cancel/{orderId}
export function cancelOrder (orderId) {
  return request({
    url: "/business/order/cancel/" + orderId,
    method: "put",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
  })
}

// 书目录树
export function getBookCatalogue (params) {
  return request({
    url: "/business/book/catalogNode",
    // method: '',
    params
  })
}

// 下订单
export function getOrder (params) {
  return request({
    url: "/business/order/saveRankOrder",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data: params
  })
}

//卡列表
export function getRankList (params) {
  return request({
    url: "/public/rank/list",
    method: "get",
    params
  })
}

//订单详情
export function orderDetail (orderId) {
  return request({
    url: "/business/order/" + orderId,
    method: "get",
  })
}

//预支付
export function getImgCode (params) {
  return request({
    url: "/business/order/pay",
    method: "get",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    params
  })
}

// 开发票
export function addInvoice (params) {
  return request({
    url: "/business/invoice/apply",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data: params
  })
}

export function getPhoneCode (params) {
  return request({
    url: "/public/phoneCode",
    method: "get"
  })
}
// 微信登录
export function wxLogin (params) {
  return request({
    url: "/wx/login",
    method: "post",
    data: params
  })
}

//手机验证码登录
export function getCaptchaImg (params) {
  return request({
    url: "/captchaImage",
    method: "get",
    data: params
  })
}
//绑定手机号
export function changeMobile (params) {
  return request({
    url: "/business/user/changeMobile",
    method: "post",
    data: params
  })
}

//綁定集團卡

export function bindCardNo (cardNo) {
  return request({
    url: "/business/user/bindCardNo?cardNo=" + cardNo,
    method: "put",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
  })
}


//卡列表
export function getBuyConfig () {
  return request({
    url: "/public/buyConfig",
    method: "get"
  })
}

//文库接口
export function getWenkuList (params) {
  return request({
    url: "/business/config/list",
    method: "get",

    params: params
  })
}


// WEBPACK FOOTER //
// ./src/api/api.js